/* Industrial PDP behaviour — qty, units, tabs, copy, 3D modal, compare */
(function () {
  const root = document;
  const page = document.querySelector("[data-ipdp]");
  if (!page) return;

  const toast = (msg) => {
    let el = document.querySelector(".ipdp-toast");
    if (!el) {
      el = document.createElement("div");
      el.className = "ipdp-toast";
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add("is-on");
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove("is-on"), 1600);
  };

  /* Quantity */
  root.querySelectorAll("[data-ipdp-qty]").forEach((wrap) => {
    const input = wrap.querySelector("input");
    wrap.querySelector("[data-minus]")?.addEventListener("click", () => {
      input.stepDown();
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
    wrap.querySelector("[data-plus]")?.addEventListener("click", () => {
      input.stepUp();
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });

  /* Copy identifiers */
  root.querySelectorAll("[data-copy]").forEach((btn) => {
    btn.addEventListener("click", async () => {
      const value = btn.getAttribute("data-copy") || "";
      try {
        await navigator.clipboard.writeText(value);
        btn.classList.add("is-on");
        const previous = btn.getAttribute("aria-label");
        btn.setAttribute("aria-label", "Copied");
        toast("Copied");
        setTimeout(() => {
          btn.classList.remove("is-on");
          if (previous) btn.setAttribute("aria-label", previous);
        }, 1200);
      } catch (e) {
        toast(value);
      }
    });
  });

  /* Unit system */
  const toInch = (raw) => {
    const text = (raw || "").trim();
    if (!text || text === "–" || text === "-") return text;
    const normalized = text.replace(/,/g, ".");
    const match = normalized.match(/^([-+]?\d+(?:\.\d+)?)(?:\s*(mm|millimet(?:er|re)s?))?$/i);
    if (!match) return text;
    const millimeters = Number(match[1]);
    if (!Number.isFinite(millimeters)) return text;
    const inches = String(Number((millimeters / 25.4).toFixed(4)));
    return match[2] ? inches + " in" : inches;
  };

  const applyUnits = (system) => {
    root.querySelectorAll("[data-metric]").forEach((el) => {
      const metric = el.getAttribute("data-metric");
      if (metric === null) return;
      const convertible = el.getAttribute("data-convert") !== "false";
      const next = system === "inch" && convertible ? toInch(metric) : metric;
      el.textContent = next;
    });
    root.querySelectorAll("[data-unit-label]").forEach((lab) => {
      lab.classList.toggle("is-on", lab.getAttribute("data-unit-label") === system);
    });
    try {
      localStorage.setItem("ipdp-units", system);
    } catch (e) {}
  };

  const saved = (() => {
    try {
      return localStorage.getItem("ipdp-units");
    } catch (e) {
      return null;
    }
  })();
  const initial = saved || page.getAttribute("data-default-unit") || "metric";
  const unitInput = root.querySelector(`input[name="ipdp-unit"][value="${initial}"]`);
  if (unitInput) unitInput.checked = true;
  applyUnits(initial);

  root.querySelectorAll('input[name="ipdp-unit"]').forEach((input) => {
    input.addEventListener("change", () => applyUnits(input.value));
  });

  /* Gallery thumbs */
  root.querySelectorAll("[data-ipdp-thumb]").forEach((thumb) => {
    thumb.addEventListener("click", () => {
      const src = thumb.getAttribute("data-full");
      const main = root.querySelector("[data-ipdp-main-image]");
      if (main && src) {
        main.src = src;
        root.querySelectorAll("[data-ipdp-thumb]").forEach((t) => t.classList.remove("is-active"));
        thumb.classList.add("is-active");
      }
    });
  });

  /* Tabs switch panels (hero stays visible). Match #id even if the theme rewrites the href. */
  const panelId = (href) => {
    if (!href) return "";
    const hash = href.split("#").pop();
    return hash || "";
  };
  const links = [...root.querySelectorAll("[data-ipdp-tab]")];
  const panels = [...root.querySelectorAll("[data-ipdp-panel]")];
  const showPanel = (id) => {
    if (!id) return;
    links.forEach((a) => a.classList.toggle("is-active", panelId(a.getAttribute("href")) === id));
    panels.forEach((p) => {
      const match = p.id === id || (p.getAttribute("data-ipdp-panel") || "").replace(/^#/, "") === id;
      p.classList.toggle("is-active", match);
      if (match) p.hidden = false;
    });
  };
  links.forEach((a) => {
    a.addEventListener("click", () => {
      const id = panelId(a.getAttribute("href"));
      if (id) showPanel(id);
    });
  });
  const hash = panelId(location.hash);
  if (hash && (document.getElementById(hash) || panels.some((p) => (p.getAttribute("data-ipdp-panel") || "").replace(/^#/, "") === hash))) {
    showPanel(hash);
  } else if (links[0]) {
    showPanel(panelId(links[0].getAttribute("href")));
  }

  /* Hide nav items whose panel was not rendered */
  root.querySelectorAll("[data-tab-item]").forEach((li) => {
    const id = li.getAttribute("data-tab-target");
    if (id && !document.getElementById(id)) li.remove();
  });

  /* 3D modal */
  const modal = root.querySelector("[data-ipdp-modal]");
  root.querySelector("[data-open-3d]")?.addEventListener("click", () => {
    modal?.classList.add("is-open");
    document.body.style.overflow = "hidden";
  });
  modal?.querySelector("[data-close-modal]")?.addEventListener("click", () => {
    modal.classList.remove("is-open");
    document.body.style.overflow = "";
  });
  modal?.addEventListener("click", (e) => {
    if (e.target === modal) {
      modal.classList.remove("is-open");
      document.body.style.overflow = "";
    }
  });


  /* Ajax add to cart from tables / spare rows */
  root.querySelectorAll("[data-add-variant]").forEach((btn) => {
    btn.addEventListener("click", async () => {
      const id = Number(btn.getAttribute("data-add-variant"));
      let qty = 1;
      const wrap = btn.closest(".ipdp-spare") || btn.closest(".ipdp-cat-row");
      const qtyInput = wrap?.querySelector("[data-qty-for], [name='quantity']");
      if (qtyInput) qty = Number(qtyInput.value) || 1;
      btn.disabled = true;
      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id, quantity: qty }),
        });
        if (!res.ok) throw new Error("add failed");
        toast("Added to cart");
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      } catch (e) {
        toast("Could not add to cart");
      } finally {
        btn.disabled = false;
      }
    });
  });

  /* Catalog filters + pagination */
  root.querySelectorAll("[data-ipdp-table]").forEach((table) => {
    const section = table.closest(".ipdp-cat") || table.parentElement;
    const rows = [...table.querySelectorAll("[data-ipdp-row]")];
    const pageSize = Number(table.getAttribute("data-page-size") || 10);
    let visibleCap = pageSize;
    const search = section.querySelector("[data-catalog-search]");
    const facetSelects = [...section.querySelectorAll("[data-facet-select]")];
    const familyBtns = [...section.querySelectorAll("[data-family-filter]")];
    const moreBtn = section.querySelector("[data-show-more]");
    const viewed = section.querySelector("[data-viewed-label]");
    const viewedTemplate = viewed?.textContent || "You've viewed [shown] of [total] products";

    facetSelects.forEach((select) => {
      const code = select.getAttribute("data-facet-select");
      const values = new Set();
      rows.forEach((row) => {
        row.querySelectorAll(`[data-col="${code}"]`).forEach((cell) => {
          const v = (cell.getAttribute("data-facet") || cell.textContent || "").trim();
          if (v && v !== "–") values.add(v);
        });
      });
      [...values].sort().forEach((v) => {
        const opt = document.createElement("option");
        opt.value = v;
        opt.textContent = v;
        select.appendChild(opt);
      });
    });

    const apply = () => {
      const q = (search?.value || "").trim().toLowerCase();
      const family = familyBtns.find((b) => b.classList.contains("is-on"))?.getAttribute("data-family-filter");
      const facets = facetSelects
        .map((s) => ({ code: s.getAttribute("data-facet-select"), value: s.value }))
        .filter((f) => f.value);
      let matchCount = 0;
      let shown = 0;
      rows.forEach((row) => {
        let ok = true;
        if (q && !(row.getAttribute("data-search") || "").includes(q)) ok = false;
        if (family && row.getAttribute("data-family") !== family) ok = false;
        facets.forEach((f) => {
          const cell = row.querySelector(`[data-col="${f.code}"]`);
          const val = (cell?.getAttribute("data-facet") || cell?.textContent || "").trim();
          if (val !== f.value) ok = false;
        });
        if (ok) matchCount += 1;
        const reveal = ok && shown < visibleCap;
        if (reveal) shown += 1;
        row.classList.toggle("is-hidden", !reveal);
      });
      if (viewed) {
        viewed.textContent = viewedTemplate
          .replace("[shown]", String(shown))
          .replace("[total]", String(matchCount));
      }
      if (moreBtn) moreBtn.hidden = shown >= matchCount;
    };

    search?.addEventListener("input", () => {
      visibleCap = pageSize;
      apply();
    });
    facetSelects.forEach((s) =>
      s.addEventListener("change", () => {
        visibleCap = pageSize;
        apply();
      })
    );
    familyBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        const on = btn.classList.contains("is-on");
        familyBtns.forEach((b) => b.classList.remove("is-on"));
        if (!on) btn.classList.add("is-on");
        visibleCap = pageSize;
        apply();
      });
    });
    moreBtn?.addEventListener("click", () => {
      visibleCap += pageSize;
      apply();
    });
    section.querySelector("[data-toggle-filters]")?.addEventListener("click", () => {
      const grid = section.querySelector(".ipdp-filters__grid");
      if (!grid) return;
      grid.hidden = !grid.hidden;
    });
    section.querySelector("[data-compare-mode]")?.addEventListener("change", (e) => {
      table.classList.toggle("compare-on", e.target.checked);
    });
    apply();
  });
})();

(function () {
  const root = document;
  const toast = (msg) => {
    let el = document.querySelector(".ipdp-toast");
    if (!el) {
      el = document.createElement("div");
      el.className = "ipdp-toast";
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add("is-on");
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove("is-on"), 1600);
  };

  /* Save to list and compare. Stored in this browser and shown in a panel. */
  const readList = (key) => {
    try {
      const raw = JSON.parse(localStorage.getItem(key) || "[]");
      if (!Array.isArray(raw)) return [];
      return raw.filter((item) => item && typeof item === "object" && item.id);
    } catch (e) {
      return [];
    }
  };
  const writeList = (key, arr) => localStorage.setItem(key, JSON.stringify(arr));
  const hero = document.querySelector("[data-ipdp][data-recent-url]");
  if (hero && hero.getAttribute("data-recent-url")) {
    const viewed = {
      id: hero.getAttribute("data-product-handle") || hero.getAttribute("data-recent-url"),
      title: hero.getAttribute("data-recent-title") || "",
      url: hero.getAttribute("data-recent-url") || "",
      image: hero.getAttribute("data-recent-image") || "",
      text: hero.getAttribute("data-recent-text") || "",
    };
    const recent = readList("ipdp-recent").filter((item) => item.id !== viewed.id);
    recent.unshift(viewed);
    writeList("ipdp-recent", recent.slice(0, 50));
  }
  const itemFrom = (btn) => ({
    id: btn.getAttribute("data-variant") || btn.getAttribute("data-copy-handle") || btn.getAttribute("data-handle"),
    handle: btn.getAttribute("data-handle") || btn.getAttribute("data-copy-handle") || "",
    title: btn.getAttribute("data-title") || "",
    sku: btn.getAttribute("data-sku") || btn.getAttribute("data-title") || btn.getAttribute("data-handle") || "Product",
    price: btn.getAttribute("data-price") || "",
    url: btn.getAttribute("data-url") || "",
    image: btn.getAttribute("data-image") || "",
  });
  const listKey = (kind) => (kind === "compare" ? "ipdp-compare" : "ipdp-saved");
  const drawer = document.querySelector("[data-ipdp-drawer]");
  const drawerBody = document.querySelector("[data-ipdp-drawer-body]");
  const drawerTitle = document.querySelector("[data-ipdp-drawer-title]");

  const refreshUtilityButtons = () => {
    const saved = readList("ipdp-saved");
    const compare = readList("ipdp-compare");
    root.querySelectorAll("[data-save-list]").forEach((btn) => {
      const id = itemFrom(btn).id;
      const on = saved.some((item) => item.id === id);
      btn.classList.toggle("is-on", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
      const label = btn.querySelector("[data-save-label]");
      if (label) label.textContent = on ? btn.getAttribute("data-saved-label") || "Saved" : btn.getAttribute("data-label") || label.textContent;
    });
    root.querySelectorAll("[data-compare]").forEach((btn) => {
      const id = itemFrom(btn).id;
      const on = compare.some((item) => item.id === id);
      btn.classList.toggle("is-on", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
      const label = btn.querySelector("[data-compare-label]");
      if (label) label.textContent = on ? btn.getAttribute("data-saved-label") || "In compare" : btn.getAttribute("data-label") || label.textContent;
    });
    const n = saved.length;
    document.querySelectorAll("[data-ipdp-list-count]").forEach((badge) => {
      badge.hidden = n < 1;
      const num = badge.querySelector("[data-ipdp-list-count-num]");
      if (num) num.textContent = String(n);
    });
    document.querySelectorAll(".ipdp-drawer [data-ipdp-open-list]").forEach((btn) => {
      const kind = btn.getAttribute("data-ipdp-open-list");
      const open = Boolean(drawer) && drawer.hidden === false;
      const active = kind === "compare" ? open && drawer.classList.contains("is-compare") : open && !drawer.classList.contains("is-compare");
      btn.classList.toggle("is-on", active);
    });
  };

  const renderDrawer = (kind) => {
    if (!drawer || !drawerBody) return;
    const items = readList(listKey(kind));
    if (drawerTitle) drawerTitle.textContent = kind === "compare" ? "Compare" : "Saved list";
    drawerBody.replaceChildren();
    drawer.classList.toggle("is-compare", kind === "compare");
    if (!items.length) {
      const empty = document.createElement("p");
      empty.className = "ipdp-drawer__empty";
      empty.textContent = kind === "compare" ? "No products to compare yet." : "No products saved yet.";
      drawerBody.appendChild(empty);
    } else {
      items.forEach((item) => {
        const row = document.createElement("article");
        row.className = "ipdp-drawer__item";
        if (item.image) {
          const img = document.createElement("img");
          img.src = item.image;
          img.alt = "";
          row.appendChild(img);
        }
        const text = document.createElement("div");
        const link = document.createElement("a");
        link.href = item.url || "#";
        link.textContent = item.sku || item.title;
        const meta = document.createElement("p");
        meta.textContent = [item.title, item.price].filter(Boolean).join(" · ");
        text.append(link, meta);
        const remove = document.createElement("button");
        remove.type = "button";
        remove.className = "ipdp-drawer__remove";
        remove.textContent = "Remove";
        remove.addEventListener("click", () => {
          writeList(listKey(kind), readList(listKey(kind)).filter((entry) => entry.id !== item.id));
          refreshUtilityButtons();
          renderDrawer(kind);
        });
        row.append(text, remove);
        drawerBody.appendChild(row);
      });
    }
    drawer.hidden = false;
    document.body.style.overflow = "hidden";
    refreshUtilityButtons();
  };

  const closeDrawer = () => {
    if (!drawer) return;
    drawer.hidden = true;
    document.body.style.overflow = "";
  };

  const toggleList = (kind, btn) => {
    const item = itemFrom(btn);
    if (!item.id) return;
    const key = listKey(kind);
    let list = readList(key);
    if (list.some((entry) => entry.id === item.id)) {
      list = list.filter((entry) => entry.id !== item.id);
    } else if (kind === "compare" && list.length >= 4) {
      toast("Compare holds 4 products. Remove one first.");
      renderDrawer(kind);
      return;
    } else {
      list.push(item);
    }
    writeList(key, list);
    refreshUtilityButtons();
    renderDrawer(kind);
  };

  document.addEventListener("click", (event) => {
    const save = event.target.closest("[data-save-list]");
    if (save) {
      event.preventDefault();
      toggleList("saved", save);
      return;
    }
    const compare = event.target.closest("[data-compare]");
    if (compare) {
      event.preventDefault();
      toggleList("compare", compare);
    }
  });
  document.querySelectorAll("[data-ipdp-drawer-close]").forEach((btn) => {
    btn.addEventListener("click", closeDrawer);
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeDrawer();
  });
  document.querySelectorAll("[data-ipdp-open-list]").forEach((btn) => {
    btn.addEventListener("click", () => renderDrawer(btn.getAttribute("data-ipdp-open-list") || "saved"));
  });
  refreshUtilityButtons();

  document.querySelectorAll("[data-suite-table]").forEach((wrap) => {
    const rows = [...wrap.querySelectorAll("[data-ipdp-row]")];
    const pageSize = Number(wrap.getAttribute("data-page-size") || 10);
    let cap = pageSize;
    const search = wrap.querySelector("[data-catalog-search]");
    const facetSelects = [...wrap.querySelectorAll("[data-facet-select]")];
    const more = wrap.querySelector("[data-show-more]");
    const viewed = wrap.querySelector("[data-viewed-label]");
    facetSelects.forEach((select) => {
      const code = select.getAttribute("data-facet-select");
      if (select.options.length > 1) return;
      const values = new Set();
      rows.forEach((row) => {
        let value = "";
        if (code === "availability") value = row.getAttribute("data-available") || "";
        else {
          const cell = row.querySelector(`[data-col="${code}"]`);
          value = (cell && (cell.getAttribute("data-facet") || cell.textContent) || "").trim();
        }
        if (value && value !== "–") values.add(value);
      });
      [...values].sort().forEach((value) => {
        const opt = document.createElement("option");
        opt.value = value;
        opt.textContent = value;
        select.appendChild(opt);
      });
    });
    const apply = () => {
      const q = (search && search.value || "").trim().toLowerCase();
      const matched = [];
      rows.forEach((row) => {
        let ok = !q || (row.getAttribute("data-search") || "").includes(q);
        facetSelects.forEach((select) => {
          if (!select.value) return;
          const code = select.getAttribute("data-facet-select");
          let value = "";
          if (code === "availability") value = row.getAttribute("data-available") || "";
          else {
            const cell = row.querySelector(`[data-col="${code}"]`);
            value = (cell && (cell.getAttribute("data-facet") || cell.textContent) || "").trim();
          }
          if (value !== select.value) ok = false;
        });
        if (ok) matched.push(row);
        row.classList.add("is-hidden");
      });
      const shown = Math.min(cap, matched.length);
      matched.forEach((row, index) => {
        if (index < shown) row.classList.remove("is-hidden");
      });
      if (viewed) viewed.textContent = "You've viewed " + shown + " of " + matched.length + " products";
      if (more) more.hidden = shown >= matched.length;
    };
    if (search) search.addEventListener("input", () => { cap = pageSize; apply(); });
    facetSelects.forEach((select) => select.addEventListener("change", () => { cap = pageSize; apply(); }));
    if (more) more.addEventListener("click", () => { cap += pageSize; apply(); });
    apply();
  });

  const syncVolume = (input) => {
    const qty = Number(input.value) || 1;
    const root = input.closest(".ipdp-spare") || input.closest(".ipdp-cat-row") || input.closest("[data-ipdp]") || input.form;
    if (!root) return;
    const breaks = [...root.querySelectorAll("[data-ipdp-break]")];
    if (!breaks.length) return;
    let active = breaks[0];
    breaks.forEach((row) => {
      if (qty >= Number(row.getAttribute("data-min") || 0)) active = row;
    });
    breaks.forEach((row) => row.classList.toggle("is-on", row === active));
    const now = root.querySelector("[data-ipdp-volume-now]");
    const money = active.querySelector("[data-money]");
    if (now && money) now.textContent = money.textContent.trim();
  };
  document.querySelectorAll("[data-ipdp-volume]").forEach((box) => {
    const root = box.closest("[data-ipdp]") || box.closest("form");
    const input = root && root.querySelector("[name='quantity']");
    if (input) syncVolume(input);
  });
  document.addEventListener("change", (event) => {
    if (event.target.name === "quantity") syncVolume(event.target);
  });

  const fitColumns = (table) => {
    const head = table.querySelector(".ipdp-table__head");
    if (!head) return;
    const parts = [...head.children]
      .filter((el) => !el.classList.contains("is-col-off"))
      .map((el) => {
        if (el.classList.contains("is-actions")) return "88px";
        if (el.classList.contains("is-product")) return "minmax(280px, 1.4fr)";
        return "minmax(90px, 0.7fr)";
      });
    const template = parts.join(" ");
    head.style.gridTemplateColumns = template;
    table.querySelectorAll(".ipdp-cat-row").forEach((row) => {
      row.style.gridTemplateColumns = template;
    });
  };
  document.querySelectorAll("[data-suite-table]").forEach((wrap) => fitColumns(wrap));
  document.addEventListener("change", (event) => {
    const input = event.target.closest("[data-col-toggle]");
    if (!input) return;
    const wrap = input.closest("[data-suite-table]");
    if (!wrap) return;
    const code = input.getAttribute("data-col-toggle");
    wrap.querySelectorAll(`[data-col="${code}"], [data-col-head="${code}"]`).forEach((el) => {
      el.classList.toggle("is-col-off", !input.checked);
    });
    fitColumns(wrap);
  });

})();
